import * as Common from '@/tenantCatalog/common';

export class CampaignEntry extends Common.StateObject{
  constructor(){
    super('CampaignEntry');
    this.state = CampaignEntryStatus.pending;
    this.workflowStateId = CampaignEntryStatus.pending;
  }
  public id :number = 0;
  public entryDate: Date;
  public campaignId :number = 0;
  public campaign : Common.Campaign;
  public tenantId: string = null;
  public tenant : Common.Tenant = null;
  public userId : string = '';
  public userName : string = '';
}

export enum CampaignEntryStatus{
  pending = 1, 
  processing = 2,
  completed=4,
  all = pending |processing| completed
}

export class CampaignEntryQuery extends Common.LoadQuery {
  constructor(){
    super('CampaignEntryQuery',CampaignEntry);
    this.sort = 'id';    
  }
  public campaign :Common.Campaign = null;
  public campaignId : number = null;
  public tenantid : string = null;
  public tenant:Common.Tenant = null;
  public state :CampaignEntryStatus = CampaignEntryStatus.processing;
}

